import { combineReducers } from 'redux';
import stats from './stats';
import dataPrecise from './updateDataPrecise';
import dataAtLeast from './updateDataAtLeast';

const rootReducer = combineReducers({
  stats,
  dataPrecise,
  dataAtLeast,
});

// what redux store looks like here
// initial:
// {}
// apps reducer
// {
//   apps: []
// }
// later
// {
//   apps: [{}, {}, {}...]
// }

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js